
const state = {
    fileInformation: null,
    fileList: [], 
  };
  
  const mutations = {
    SET_FILE_INFORMATION(state, fileInformation) {
      state.fileInformation = fileInformation;
    },
    ADD_FILE_TO_LIST(state, file) {
        state.fileList.push(file); // Add the file to the array
    },
    RESET_STATE(state) {
        state.fileInformation = null;
        state.fileList = []; 
    }
  };
  
  const actions = {
    setFileInformation({ commit }, fileInformation) {
      commit('SET_FILE_INFORMATION', fileInformation);
    },
    addFileToList({ commit }, file) {
        commit('ADD_FILE_TO_LIST', file);
    },
    resetState({ commit }) {
        commit('RESET_STATE');
    }
  };
  
  const getters = {
    getFileInformation: state => state.fileInformation,
    getFileList: state => state.fileList, 
  };
  
  export default {
    state,
    mutations,
    actions,
    getters
  };
  